export default {
    request_device_log_title: "Request Device Log",
    request_device_log_request_log_command_has_been_sent: "Request log command has been sent",
    request_device_log_error_sending_the_command: "Error sending the command",
    request_device_log_label: "Use this feature to escalate VidFleet with issues related to the selected device. Please enter a detailed description about the issue next",
    request_device_log_request_log: "Request Log",
    request_device_log_min_characters: "The description must contain at least 5 characters",
}